import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ClubServicesService } from 'src/app/shared/services/club-services.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { ManageOrderderService } from 'src/app/shared/services/manage-orderder.service';

@Component({
  selector: 'app-select-delivery-method',
  templateUrl: './select-delivery-method.component.html',
  styleUrls: ['./select-delivery-method.component.scss','../../../modules/dashboard/organization-dash/organization-dash.component.scss']
})
export class SelectDeliveryMethodComponent implements OnInit {

  checkForm = this.fb.group({
    checkbox: new FormControl('', [Validators.required]),
  })

  deliveryCheckboxSelected = false;
  pickupCheckboxSelected = false;

  constructor(
    private fb: FormBuilder,
    private modalService: BsModalService,
    private csObj: CommonService,
    private toast: ToastrService,
    private dialogue: MatDialog,
    private router: Router,
    private clubServ: ClubServicesService,
    private spinner: SpinnerVisibilityService,
    private manageOrdersServices: ManageOrderderService,
  ) { }

  ngOnInit(): void {
  }

  @Input() selectRestaurantData;
  @Output() closeModalDeliveryMethodPopup = new EventEmitter();

  closeModalDeliveryMethod(){
    this.closeModalDeliveryMethodPopup.emit();
  }

  delieveryCheckBoxText: string = '';

  onDeliveryCheckboxChange(e) {
    // e.target.checked==true
    if(e.checked==true){
      this.deliveryCheckboxSelected = true;
      this.pickupCheckboxSelected = false;
      this.delieveryCheckBoxText = 'delivery';
    }else{
      this.deliveryCheckboxSelected = false;
      this.pickupCheckboxSelected = false;
      this.delieveryCheckBoxText = undefined;
    }
     // Uncheck the pickup checkbox when the delivery checkbox is checked
  }

  onPickupCheckboxChange(e) {
    // e.target.checked==true
    if(e.checked==true){
      this.pickupCheckboxSelected = true;
      this.deliveryCheckboxSelected = false;
      this.delieveryCheckBoxText = 'pickup';
    }else{
      this.pickupCheckboxSelected = false;
      this.deliveryCheckboxSelected = false;
      this.delieveryCheckBoxText = undefined;
    }
     // Uncheck the delivery checkbox when the pickup checkbox is checked
  }

  @Output() clickAddEvent = new EventEmitter();

  onclickAddEvent() {

    this.clickAddEvent.emit(this.delieveryCheckBoxText);

    // try {
    //   this.spinner.show();


    //   let req_body = {

    //     "eventTitle": this.eventForm.value.title,
    //     "eventDate": this.datepipe.transform(this.eventForm.value.date, 'dd-MMM-YYYY'),
    //     "deliveryTime": this.deleveryTimeVal,
    //     "teams": this.teamArr,
    //     "deliveryMethod": this.delieveryCheckBoxText,
    //     "restaurantId": this.selectForm.value.check,
    //     // "eventTime": this.eventForm.value.delivary,
    //     "comment": this.eventForm.value.comment,
    //   }

    //   if (!this.eventForm.value.comment) {
    //     delete req_body.comment
    //   }
    //   this.clubServ.addEvent(req_body).subscribe(
    //     (res: any) => {
    //       console.log(res);
    //       this.delieveryCheckBoxText = undefined;
    //       this.checkedVal = false;
    //       this.eventForm.reset();
    //       this.selectForm.reset();
    //       this.checkForm.reset();
    //       this.modalRef.hide();
    //       this.deliveryCheckboxSelected = undefined;
    //       this.pickupCheckboxSelected = undefined;
    //       this.successCreation();
    //       this.spinner.hide();
    //       this.getClubListAPICall();
    //     },
    //     (err: any) => {
    //       this.delieveryCheckBoxText = undefined;
    //       this.checkedVal = false;
    //       this.eventForm.reset();
    //       this.selectForm.reset();
    //       this.checkForm.reset();
    //       this.spinner.hide();
    //       this.modalRef.hide();
    //       this.deliveryCheckboxSelected = undefined;
    //       this.pickupCheckboxSelected = undefined;
    //       // this.toast.error("Error on adding events.");
    //     }
    //   )
    // }
    // catch (e) { }
  }

}
